<template>
  <div class="homeCenter clearfix">
    <div class="titleBox mb-5">
      <h2 class="m-0">
        <span>个人中心</span>
        <button @click='toBack' class="btn btn-outline-dark btn-round d-block d-lg-none">商城 <i class="iconfont icon-qianwang"></i></button>
      </h2>
      <hr>
      <p class="content">
        专业的音乐设备，数码乐器，数字音频，我们提供“一站式”音频解决方案！
      </p>
    </div>
    <div class="iconfontBox">
        <router-link tag='span' class="cursor" to="/home/message">
          <i class="iconfont icon-notice"></i>
          消息
        </router-link>
        <router-link tag='span' class="cursor" to="/about/lianxi">
          <i class="iconfont icon-kefu"></i>
          客服
        </router-link>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';

export default {
  name: 'homeCenter',
  mixins: [generalMix],
  data () {
    return {
    }
  },
  methods:{
  },
  created() {
  },
  components: {
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>
	.homeCenter {
    .titleBox {
      margin-top: 30px;
      margin-bottom: 30px;
      p {
        margin: 0;
      }
    }
    div.iconfontBox{
      display: flex;
      span{
        background: rgba(0,0,0,0.05);
        width: 120px;
        height: 120px;
        border-radius: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: relative;
        margin-right: 10px;
        i{
          font-size: 46px;
        }
        b{
          position: absolute;
          top: 5px;
          right: 5px;
          background: rgba(255,255,255,0.5);
          border-radius: 25px;
          padding: 0 10px;
        }
      }
    }
    div.jiazaiBox{
      margin-bottom: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      box-shadow: 0 0 6px rgba(0, 0, 0, .2);
      background: #FFFFFF;
      min-height: 300px;
      .spinner-border{
        width: 3rem;
        height: 3rem;
      }
    }
  }
  @media (max-width: 1200px) {
    .homeCenter{
    }
  }
  @media (max-width: 992px) {
    .homeCenter{
      .titleBox {
        margin-top: 0;
        h2{
          display: flex;
          justify-content: space-between;
        }
        p {
          margin: 0;
          color: #9B9B9B;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .homeCenter{
      .titleBox {
        p{
          padding: 0 15px;
        }
      }
      div.iconfontBox{
        display: flex;
        span{
          width: 100px;
          height: 100px;
          i{
            font-size: 36px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/Center.vue